/* ═══════════════════════════════════════════════════════
   PINE PARK ARCADE: Age Gate Modal
   Vanilla JS, ES5 compatible. No jQuery, no frameworks.

   Flow:
     1. On load: check pp_age_verified cookie.
        • Set → do nothing.
        • Not set → show modal (Screen 1).
     2. YES click → set cookie, go to Screen 2
        (or close immediately, as SKIP does, if pp_email_collected is set,
        the email screen is off in the Customizer, the visit came from an
        ad on this page or earlier in the session, or the page is a landing
        template).
     3. NO click → show "GAME OVER" block screen (no cookie, no exit).
     4. Email submit → AJAX POST to Shopify customer endpoint,
        show success flash, then close.
     5. SKIP click → close modal (age cookie already set).

   Scroll lock: iOS-safe pattern (save scrollY, position:fixed).
   ═══════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ══════════════════════════════════════
     COOKIE HELPERS
     ══════════════════════════════════════ */

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var d = new Date();
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + d.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }

  function getCookie(name) {
    var nameEQ = name + '=';
    var parts = document.cookie.split(';');
    for (var i = 0; i < parts.length; i++) {
      var c = parts[i];
      while (c.charAt(0) === ' ') c = c.substring(1);
      if (c.indexOf(nameEQ) === 0) {
        return decodeURIComponent(c.substring(nameEQ.length));
      }
    }
    return null;
  }

  /* ══════════════════════════════════════
     AD VISITS (mobile Phase 6, Batch 8)
     A visit is an ad visit when the URL has a utm_medium containing "paid"
     (any case), or has fbclid with a utm_medium that is absent or anything
     but "social" (the Instagram bio link carries utm_medium=social with
     fbclid and is not an ad). The flag lives in sessionStorage as
     pp_ad_visit so later pages in the same session count too. Ad visitors,
     and every visitor on a landing template, skip the email screen.
     ══════════════════════════════════════ */

  function urlParam(name) {
    var match = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.search || '');
    if (!match) return null;
    try {
      return decodeURIComponent(match[1].replace(/\+/g, ' '));
    } catch (err) {
      return match[1];
    }
  }

  function isAdArrival() {
    var medium = urlParam('utm_medium');
    var lower = medium === null ? '' : medium.toLowerCase();
    if (lower.indexOf('paid') !== -1) return true;
    return urlParam('fbclid') !== null && lower !== 'social';
  }

  function readAdFlag() {
    try {
      return window.sessionStorage.getItem('pp_ad_visit') === '1';
    } catch (err) {
      return false;
    }
  }

  function writeAdFlag() {
    try {
      window.sessionStorage.setItem('pp_ad_visit', '1');
    } catch (err) { /* storage blocked: this page still counts */ }
  }

  /* The landing gate is template.suffix starting with "landing" (CLAUDE.md
     rule 67); the layout's body class is template-product-<suffix>. */
  function isLandingPage() {
    return /(^|\s)template-product-landing/.test(document.body.className);
  }

  /* ══════════════════════════════════════
     SCROLL LOCK, iOS-safe
     Matches the pattern from coming-soon-modal.js
     ══════════════════════════════════════ */

  function lockScroll() {
    var scrollY = window.scrollY || window.pageYOffset;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top      = '-' + scrollY + 'px';
    document.body.style.width    = '100%';
    document.body.dataset.agScrollY = String(scrollY);
  }

  function unlockScroll() {
    var savedY = parseInt(document.body.dataset.agScrollY || '0', 10);
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top      = '';
    document.body.style.width    = '';
    delete document.body.dataset.agScrollY;
    window.scrollTo(0, savedY);
  }

  /* ══════════════════════════════════════
     FOCUS TRAP
     ══════════════════════════════════════ */

  function getFocusable(container) {
    var sel = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled]):not([type="hidden"])',
      'textarea:not([disabled])',
      'select:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(',');
    var all = container.querySelectorAll(sel);
    var visible = [];
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.offsetParent !== null || el.offsetWidth > 0 || el.offsetHeight > 0) {
        visible.push(el);
      }
    }
    return visible;
  }

  function trapFocus(e, modal) {
    var focusable = getFocusable(modal);
    if (!focusable.length) return;
    var first = focusable[0];
    var last  = focusable[focusable.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  /* ══════════════════════════════════════
     MODULE STATE
     ══════════════════════════════════════ */

  var modal         = null;
  var screensInner  = null;
  var btnYes        = null;
  var btnNo         = null;
  var btnSkip       = null;
  var btnSubmit     = null;
  var emailInput    = null;
  var emailError    = null;
  var blockedScreen = null;
  var successEl     = null;
  var newsletterForm = null;
  var currentScreen = 0; /* 0 = age, 1 = email */
  var cookieDays    = 30; /* default; overridden in init() from data-cookie-days */
  var emailScreenEnabled = 'true'; /* overridden in init() from data-email-screen */
  var adVisit       = false; /* set in init() from the URL or the session flag */

  /* ══════════════════════════════════════
     OPEN MODAL
     ══════════════════════════════════════ */

  function openModal() {
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('ag-open');
    lockScroll();
    /* Focus first button after animation starts */
    setTimeout(function () {
      if (btnYes) btnYes.focus();
    }, 80);
  }

  /* ══════════════════════════════════════
     CLOSE MODAL (with exit animation)
     ══════════════════════════════════════ */

  function closeModal() {
    if (!modal.classList.contains('ag-open')) return;
    modal.classList.add('ag-closing');
    setTimeout(function () {
      modal.classList.remove('ag-open', 'ag-closing');
      modal.setAttribute('aria-hidden', 'true');
      unlockScroll();
    }, 350);
  }

  /* ══════════════════════════════════════
     SCREEN TRANSITIONS
     ══════════════════════════════════════ */

  /* Slide screens-inner: 0% = Screen 1, -50% = Screen 2 */
  function goToScreen(index) {
    currentScreen = index;
    screensInner.style.transform = 'translateX(-' + (index * 50) + '%)';
    /* Focus first focusable in the new screen */
    setTimeout(function () {
      var screens = screensInner.querySelectorAll('.ag-screen');
      if (screens[index]) {
        var focusable = getFocusable(screens[index]);
        if (focusable.length) focusable[0].focus();
      }
    }, 420);
  }

  /* Show the under-21 block screen (fades in as absolute overlay) */
  function goBlocked() {
    blockedScreen.setAttribute('aria-hidden', 'false');
    blockedScreen.classList.add('ag-blocked-active');
    /* Focus the blocked headline: tabIndex set here so it receives focus */
    var headline = document.getElementById('ag-blocked-title');
    if (headline) {
      headline.setAttribute('tabindex', '-1');
      setTimeout(function () { headline.focus(); }, 100);
    }
  }

  /* ══════════════════════════════════════
     EMAIL VALIDATION
     ══════════════════════════════════════ */

  function isValidEmail(val) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
  }

  function setEmailError(msg) {
    if (!emailError) return;
    emailError.textContent = msg;
    if (msg) {
      emailInput.classList.add('ag-input-invalid');
      emailInput.setAttribute('aria-invalid', 'true');
    } else {
      emailInput.classList.remove('ag-input-invalid');
      emailInput.removeAttribute('aria-invalid');
    }
  }

  /* ══════════════════════════════════════
     NEWSLETTER SUBMIT (AJAX)
     ══════════════════════════════════════ */

  function submitNewsletter(e) {
    e.preventDefault();

    var email = emailInput ? emailInput.value.trim() : '';
    if (!email || !isValidEmail(email)) {
      setEmailError('Please enter a valid email address.');
      if (emailInput) emailInput.focus();
      return;
    }
    setEmailError('');

    /* Disable button while submitting */
    if (btnSubmit) {
      btnSubmit.disabled = true;
      btnSubmit.textContent = 'TRANSMITTING...';
    }

    var formData = new FormData(newsletterForm);

    fetch(newsletterForm.action, {
      method: 'POST',
      body: formData,
      credentials: 'same-origin'
    }).then(function () {
      setCookie('pp_email_collected', 'true', cookieDays);
      showSuccess();
    }).catch(function () {
      /* On network error, still close gracefully */
      closeModal();
    });
  }

  /* ══════════════════════════════════════
     SUCCESS FLASH
     ══════════════════════════════════════ */

  function showSuccess() {
    successEl.setAttribute('aria-hidden', 'false');
    successEl.classList.add('ag-success-show');
    setTimeout(function () {
      closeModal();
    }, 1500);
  }

  /* ══════════════════════════════════════
     KEYBOARD: Escape + Focus Trap
     ══════════════════════════════════════ */

  function onKeyDown(e) {
    if (!modal.classList.contains('ag-open')) return;

    /* Block escape entirely: user must answer Screen 1.
       Allow escape only on Screen 2 (acts like Skip). */
    if (e.key === 'Escape') {
      e.preventDefault();
      if (currentScreen === 1) {
        /* Already age-verified (cookie set before reaching screen 2) */
        closeModal();
      }
      /* Screen 0: ignore, forced interaction */
      return;
    }

    if (e.key === 'Tab') {
      trapFocus(e, modal);
    }
  }

  /* ══════════════════════════════════════
     INIT
     ══════════════════════════════════════ */

  function init() {
    modal = document.getElementById('age-gate-modal');
    if (!modal) return;

    /* Skip in Shopify Customizer: modal blocks the editor */
    if (window.Shopify && window.Shopify.designMode) return;

    /* Ad visit: recorded before the age cookie check below, so an arrival
       is kept for the session even on a page where the gate does not show. */
    if (isAdArrival()) {
      adVisit = true;
      writeAdFlag();
    } else {
      adVisit = readAdFlag();
    }

    /* If age already verified, bail: don't show anything */
    if (getCookie('pp_age_verified')) return;

    /* Read customizer-controlled settings from data attributes */
    var rawDays = parseInt(modal.getAttribute('data-cookie-days') || '30', 10);
    cookieDays = (!isNaN(rawDays) && rawDays >= 1) ? rawDays : 30;
    /* "false" only when the merchant unticks the email screen; any other
       value (including a missing attribute) keeps screen 2 on. */
    emailScreenEnabled = modal.getAttribute('data-email-screen') || 'true';

    /* Grab elements */
    screensInner   = document.getElementById('ag-screens-inner');
    btnYes         = document.getElementById('ag-btn-yes');
    btnNo          = document.getElementById('ag-btn-no');
    btnSkip        = document.getElementById('ag-skip');
    btnSubmit      = document.getElementById('ag-btn-submit');
    emailInput     = document.getElementById('ag-email-input');
    emailError     = document.getElementById('ag-email-error');
    blockedScreen  = document.getElementById('ag-screen-blocked');
    successEl      = document.getElementById('ag-success');
    newsletterForm = document.getElementById('ag-newsletter-form');

    /* Show modal */
    openModal();

    /* ── YES: age verified → go to email (or close if email already collected,
       if the merchant turned the email screen off in the Customizer, if the
       visit came from an ad, or on a landing template) ── */
    btnYes.addEventListener('click', function () {
      setCookie('pp_age_verified', 'true', cookieDays);
      if (getCookie('pp_email_collected') || emailScreenEnabled === 'false' || adVisit || isLandingPage()) {
        /* Same as the SKIP path: close without subscribing. */
        closeModal();
      } else {
        goToScreen(1);
      }
    });

    /* ── NO: under 21 → show block screen, no cookie ── */
    btnNo.addEventListener('click', function () {
      goBlocked();
    });

    /* ── SKIP: close without subscribing ── */
    if (btnSkip) {
      btnSkip.addEventListener('click', function () {
        closeModal();
      });
    }

    /* ── Email form submit ── */
    if (newsletterForm) {
      newsletterForm.addEventListener('submit', submitNewsletter);
    }

    /* ── Clear validation on input ── */
    if (emailInput) {
      emailInput.addEventListener('input', function () {
        if (emailInput.value.trim()) setEmailError('');
      });
    }

    /* ── Keyboard (escape + focus trap) ── */
    document.addEventListener('keydown', onKeyDown);

    /* ── NO backdrop click to close (forced interaction) ── */
    /* Intentionally not binding backdrop click */
  }

  document.addEventListener('DOMContentLoaded', init);

})();
